import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ManageStudents} from "./manageStudents";


const routes: Routes = [
  {
    path: 'manageStudents',
    component: ManageStudents,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManageStudentsRoutingModule {}
